<!-- 忘记密码 -->
<template>
	<div class="register">
		<div class="logo">
			<img src="../../assets/images/User/logo.png" alt="">
		</div>
		<div class="registerForm">
			<van-cell-group>
			  <van-field v-model="formData.mobile" placeholder="请输入手机号" clearable />
			</van-cell-group>
			<van-cell-group>
			  <van-field v-model="formData.code" placeholder="请输入手机号" clearable />
			  <button @click="sendCode">{{sendTimeText}}</button>
			</van-cell-group>
			<van-cell-group>
			<van-field v-model="formData.pwd" placeholder="请输入密码" clearable type="password"/>
			</van-cell-group>
			<van-cell-group>
			<van-field v-model="formData.repwd" placeholder="请确认密码" clearable type="password"/>
			</van-cell-group>
			<button class="registerBtn" @click="register">确定</button>	
		</div>
		
		<div class="tip" ref="tip">专注血管外科领域宣传与继续教育新媒体</div>
	</div>
</template>
<script>
	import {SendCode,Register} from '../../config/interface.js'
	let codeTimer;
	export default{
		data(){
			return{
				sendTimeText:'获取验证码',
				formData:{
					mobile:'',
					code:'',
					pwd:'',
					repwd:''
				},
				countdown:60,
				isReSend:true,     //能否再次点击发送验证码
			}
		},
		mounted(){
			let screenHeight = document.documentElement.clientHeight;
			window.onresize=()=>{
				if(screenHeight>document.documentElement.clientHeight){
					this.$refs.tip.style.position='static';
				}else{
					this.$refs.tip.style.position='absolute';
				}
			}
		},
		methods:{
			//验证手机号
			verifyMobile(){
				let mobile=this.formData.mobile;
				if(mobile==''){
					common.toast('请输入手机号',1000)
				}else if(!(/^1[3456789]\d{9}$/.test(mobile))){
					common.toast('请输入正确的手机号',1000)
				}else{
					return true;
				}
				return false;
			},
			//点击发送验证码
			sendCode(){
				if(this.isReSend&&this.verifyMobile()){
					this.getCode();
					this.isReSend=false;
				}
			},
			//得到验证码
			getCode(mobile){
				this.sendTime();
				const url=SendCode;
				const method='POST';
				let params={
					mobile:this.formData.mobile,
					type:1    //为1时是重置密码
				}
				fetch(url,params,method)
				.then((res)=>{
					console.log(res.code);
					if(res.code==0){
						common.toast('发送成功',1000)
					}else{
						console.log(111)
					}
				})

			},
			sendTime(){
				if(this.countdown==1){
					this.clearCodeTimer();
					return;
				}else{
					this.countdown--;
					this.sendTimeText='重新发送('+this.countdown+')s';
				  	codeTimer=setTimeout(()=>{
				  		setTimeout(this.sendTime(), 1000);
				  	}, 1000)
				}
			},
			//清除定时器
			clearCodeTimer(){
				clearTimeout(codeTimer);
				this.isReSend=true;
				this.sendTimeText="获取验证码";
				this.countdown=60;
			},
			//验证表单
			verifyForm(){
					if(!this.verifyMobile()){

					}else if(this.formData.code==''){
						common.toast('请输入验证码',1000)
					}else if(this.formData.pwd==''){
						common.toast('请输入密码',1000)
					}else if(this.formData.pwd.length<6){
						common.toast('密码不得少于6位',1000)
					}else if(this.formData.repwd==''){
						common.toast('请确认密码',1000)
					}else if(this.formData.repwd.length<6){
						common.toast('密码不得少于6位',1000)
					}else if(this.formData.pwd!=this.formData.repwd){
						common.toast('请确认两次密码一致',1000)
					}else{
						return true;
					}
					return false;
			},
			//注册
			register(){
				if(this.verifyForm()){
					const url=Register;
					const method='POST'
					let params={
						mobile:this.formData.mobile,
						msgcode:this.formData.code,
						password:this.formData.pwd,
						password_confirmation:this.formData.repwd
					}
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							common.toast('注册成功',1000,'success',()=>{
								this.$router.push({
				       			 path:'/user/login',
			    				})
							})
						}
					})
				}
			}


		}
	}
</script>
<style lang="scss">
	.register{
		width:100%;
		height:100%;
		position:relative;
		.logo{
			padding:38px 0;
			text-align:center;
			img{
				width:80%;
			}
		}
		.registerForm{
			.van-cell-group{
				width:295px;
				height:44px;
				box-sizing:border-box;
				margin:0 auto;
				margin-bottom:20px;
				@include flex(row);
				align-items:center;
				border: 1px solid #D3D3D3;
				border-radius: 23px;
				padding-left:15px;
				padding-right:5px;
				.van-cell{
					padding:0px 10px;
					background:transparent;
					input{
						height:44px;
					}
					input::-webkit-input-placeholder{
						color:#ababab;
						font-size:14px;
					}
				}
				button{
					width:140px;
					border:0px;
					color:$color-main;
					background:#fff;
					border-left:1px solid $color-main;
				}
			}
			.registerBtn{
				display:block;
				margin:0 auto;
				width:295px;
				height:44px;
				background: #901d22;
				font-size:17px;
				color:#fff;
				border:0px;
				border-radius:23px;
			}			
		}
		.operation{
			width:180px;
			margin:20px auto;
			@include flex(row);
			justify-content: space-around;
			align-items:center;
			a{
				color:#666;
				font-size:14px
			}
		}
		.tip{
			position:absolute;
			bottom:20px;
			width:100%;
			text-align:center;
			font-size:13px;
			color:$color-main;
			letter-spacing:.5px;
		}		
	}
</style>


// WEBPACK FOOTER //
// src/pages/User/forget.vue